import React from 'react';
import { PageContainer } from '@ant-design/pro-layout';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { message } from 'antd';
import { useMutation, useQuery } from '@apollo/client';
import ProjectHeader from '../ProjectHeader';
import TerminationForm from './components/TerminationForm';
import { useHasScopeTypeInProject, useProjectFrozen } from '../../../hooks';
import { GET_PROJECTS } from '../../../gql/projects';
import {
  SUBMIT_TERMINATION_WITH_CUSTOM_DATE,
  SUBMIT_TERMINATION,
  GET_LATEST_TERMINATION,
} from '../../../gql/termination';

const Termination = () => {
  const { projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { data, loading } = useQuery(GET_LATEST_TERMINATION, {
    variables: { projectId },
  });
  const { hasScopeType, loading: scopeLoading } = useHasScopeTypeInProject(
    'WRITE_TERMINATION_WITH_CUSTOM_DATE'
  );
  const [submitTermination] = useMutation(
    hasScopeType ? SUBMIT_TERMINATION_WITH_CUSTOM_DATE : SUBMIT_TERMINATION,
    {
      refetchQueries: [
        {
          query: GET_PROJECTS,
          variables: {
            ids: [projectId],
          },
        },
        {
          query: GET_LATEST_TERMINATION,
          variables: {
            projectId,
          },
        },
      ],
      onCompleted: ({
        submitTermination: {
          project: { title },
        },
      }) => {
        message.success(`Project ${title} successfully terminated`);
      },
    }
  );

  const onFinish = async ({ reason, date }) => {
    const input = {
      projectId,
      reason,
    };
    if (hasScopeType) {
      input.date = moment(date).format('YYYY-MM-DD');
    }
    await submitTermination({ variables: { input } });
  };

  const isTerminated = data?.latestTermination?.isTerminated;
  const initialValues = isTerminated
    ? {
        date: data?.latestTermination?.termination?.date,
        reason: data?.latestTermination?.termination?.reason,
      }
    : {
        date: moment(),
      };

  return (
    <ProjectHeader>
      <PageContainer title="Termination" loading={scopeLoading || loading}>
        <TerminationForm
          onFinish={onFinish}
          withCustomDate={hasScopeType}
          projectFrozen={projectFrozen}
          isTerminated={isTerminated}
          initialValues={initialValues}
        />
      </PageContainer>
    </ProjectHeader>
  );
};

export default Termination;
